import React, { useEffect, useMemo, useState } from "react";

import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import { Box } from "@mui/material";

import { useSelector } from "react-redux";

import { getAuditLog } from "helpers/Sources/activityLog";

import EmptyState from "components/atoms/EmptyState";
import PageContainer from "components/atoms/PageContainer";
import GenericTable from "components/organisms/GenericTable";

import { createActivityLogColumns } from "./ActivityLog.helpers";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const ActivityLog = () => {
    const language = useSelector((state) => state.languagesState.languages);
    const [loading, setLoading] = useState(true);
    const [logData, setLogData] = useState([]);
    const [pageSize, setPageSize] = useState(PAGE_SIZE_OPTIONS[0]);

    useEffect(() => {
        let cancelled = false;

        const fetch = async () => {
            setLoading(true);
            const response = await getAuditLog();
            if (cancelled) return;

            if (response.status) {
                setLoading(false);
                setLogData(response?.data);
            }
            setLoading(false);
        };

        fetch();
        return () => {
            cancelled = true;
        };
    }, []);

    const columns = useMemo(
        () => createActivityLogColumns({ language }),
        [language],
    );

    return (
        <PageContainer
            title={language?.activity_log?.title ?? "Activity Log"}
            subtitle={
                language?.activity_log?.subtitle ??
                "Review recent account activity and audit events."
            }
            showBackButton={false}
            variant="list"
            loading={loading && logData.length === 0}
        >
            <Box
                sx={{
                    maxWidth: "100%",
                    minWidth: 0,
                    width: "100%",
                    position: "relative",
                }}
            >
                <GenericTable
                    columns={columns}
                    rows={logData}
                    getRowKey={(row) => row.id}
                    emptyState={
                        <EmptyState
                            icon={<HistoryOutlinedIcon />}
                            title="No activity yet"
                            description="When account activity is recorded, it will appear here."
                        />
                    }
                    loading={false}
                    pageSize={pageSize}
                    onPageSizeChange={setPageSize}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    columnToggle
                    ellipsis={false}
                    tableName="activity-log"
                />
            </Box>
        </PageContainer>
    );
};

export default ActivityLog;
